import styled from 'styled-components'
import { dimensions } from '~/constants/theme'

export const ListViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
  width: ${dimensions.sidebarWidth}px;
  background-color: var(--chakra-colors-bg-subtle);
`
export const DetailViewWrapper = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
`
export const DetailViewNoContentWrapper = styled.div`
  display: flex;
  flex: 1;
  justify-content: center;
  align-items: center;
  background-color: var(--chakra-colors-bg-muted);
`
